// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import * as firebase from 'firebase/app'
// import 'firebase/auth'
import firebase from 'firebase'
import BootstrapVue from 'bootstrap-vue'
import Meta from 'vue-meta'
import store from './store'
import {sync} from 'vuex-router-sync'
import API from './services/API'
import {getConfig} from './config/config'
import VueSweetalert2 from 'vue-sweetalert2'
import VeeValidate from 'vee-validate'
import i18n from './assets/i18n/lang'

const config = getConfig()

var SocialSharing = require('vue-social-sharing')

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Meta)
Vue.use(VueSweetalert2)
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})
Vue.use(require('vue-moment'))
Vue.use(SocialSharing)

sync(store, router)

let app

firebase.initializeApp(config.firebaseConfig)
firebase.auth().onAuthStateChanged((user) => {
    let currentUser = firebase.auth().currentUser
    if (currentUser != null) {
        API.init()
            .then(() => API.logInBackend())
            .catch((error) => console.log(error))
        fireUpApp()
    } else {
        fireUpApp()
    }
})

function fireUpApp () {
    if (!app) {
        /* eslint-disable no-new */
        app = new Vue({
            el: '#app',
            router,
            store,
            i18n,
            components: {App},
            template: '<App/>'
        })
    }
}



// WEBPACK FOOTER //
// ./src/main.js